<!-- List of references -->
<app-offer-data-management-list-references *ngIf="selectedRange && (selectedRange.status === 'CONFIGURED' || selectedRange.status === 'TEST')"
                                           [selectedRange]="selectedRange"
                                           (addReferenceToNewRange)="addReference()">
</app-offer-data-management-list-references>
